'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = Input;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./input.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Input Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>}  HTML markup for the component
 */
function Input(props) {
    var _cx;

    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        id = props.id,
        isChecked = props.isChecked,
        _props$isDisabled = props.isDisabled,
        isDisabled = _props$isDisabled === undefined ? false : _props$isDisabled,
        onBlur = props.onBlur,
        onChange = props.onChange,
        onFocus = props.onFocus,
        placeholder = props.placeholder,
        _props$style = props.style,
        style = _props$style === undefined ? '' : _props$style,
        _props$type = props.type,
        type = _props$type === undefined ? 'text' : _props$type,
        value = props.value,
        _props$name = props.name,
        name = _props$name === undefined ? '' : _props$name,
        autoCapitalize = props.autoCapitalize,
        autoComplete = props.autoComplete,
        autoCorrect = props.autoCorrect,
        isAutofocused = props.isAutofocused,
        isSpellchecked = props.isSpellchecked,
        onKeyDown = props.onKeyDown,
        refCallback = props.refCallback;


    var classNames = (0, _classnames2.default)((_cx = {
        'sb-input': type !== 'radio' || type !== 'checkbox'
    }, (0, _defineProperty3.default)(_cx, 'sb-input--' + type, type === 'radio' || type === 'checkbox'), (0, _defineProperty3.default)(_cx, 'sb-input--' + style, style), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

    return _react2.default.createElement('input', {
        id: id,
        type: type,
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: onChange,
        disabled: isDisabled,
        checked: isChecked,
        className: classNames,
        placeholder: placeholder,
        value: value,
        name: name,
        autoCapitalize: autoCapitalize,
        autoComplete: autoComplete,
        autoCorrect: autoCorrect,
        autoFocus: isAutofocused,
        spellCheck: isSpellchecked,
        onKeyDown: onKeyDown,
        ref: refCallback
    });
}
// css
//# sourceMappingURL=Input.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/input/Input.js
// module id = 561
// module chunks = 0